import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }

import {onMounted, reactive, UnwrapRef} from "vue";
import ProcessForm from "@/views/workflow/process/form.vue"
import {searchProcess, startProcess} from "@/api/workflow_process";
import router from "@/router";
import { message } from "ant-design-vue";

interface Data {
  loading: boolean;
  dataSource: any[];
  pagination: any;
  processId: number,
  name: string,
  comment: string,
  type: number,
  form_visible: boolean,
  form_loading: boolean
}



export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {


const columns = [
  {
    title: "代码",
    dataIndex: "code",
    key: "code",
    width: "10%"
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    width: "10%"
  },
  {
    title: "备注",
    dataIndex: "comment",
    key: "comment",
    width: "15%"
  },
  {
    title: "文件名",
    dataIndex: "fileName",
    key: "fileName",
  },
  {
    title: "状态",
    dataIndex: "available",
    key: "available",
    width: "10%"
  },
  {
    title: "操作",
    dataIndex: "operation",
    width: "10%"
  },
];

let data: UnwrapRef<Data> = reactive({
  loading: true,
  dataSource: [],
  processId: 0,
  name: "",
  comment: "",
  form_visible: false,
  form_loading: false,
  pagination: {
    size: "small",
    current: 1,
    pageSize: 10,
    total: 0,
    pageSizeOptions: ["10", "20", "30"],
    showTotal: (total: string) => {
      return " 共" + total + "条";
    },
    hideOnSinglePage: true,
    showSizeChanger: true,
  },
  type: 0
});


const init = () => {
  search();
}


const submit = () => {
  search();
};


const hideForm = (values: any) => {
  data.form_visible = false;
  console.log(values)
};

// const onSearchFormFinish = () => {
//   search();
// };

// const searchFormState = reactive({
//   keyword: "",
//   type: 1
// });

const changePageIndex = (page: any) => {
  data.pagination.pageSize = page.pageSize;
  data.pagination.current = page.current;
  search();
};

const search = () => {
  data.loading = true
  searchProcess().then((res: any[]|null) => {
    data.loading = false;
    data.dataSource = [];
    if (null !== res) {
      data.dataSource = res
    }
  });
}

const onStartProcess = (record: any) => {
  startProcess({"processKey":record.code}).then(()=> {
    message.success('开启成功')
    router.push({
      path: "/home",
    });
  })
}

const edit = (record: any) => {
  data.processId = record.id
  data.name = record.name
  data.comment = record.comment
  data.type = 1
  data.form_visible = true
};

const create = () => {
  data.type = 0
  data.form_visible = true
};

const view = (id: any) => {
  console.log(id);
  router.push({
    path: '/workflow/process/view',
    query: {
      id
    }
  })
};

onMounted(() => {
  init();
})


return (_ctx: any,_cache: any) => {
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      dataSource: _unref(data).dataSource,
      columns: columns,
      loading: _unref(data).loading,
      scroll: { y:400},
      size: "small",
      pagination: false,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'available')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.available)
                ? (_openBlock(), _createBlock(_component_CheckOutlined, { key: 0 }))
                : (_openBlock(), _createBlock(_component_CloseOutlined, { key: 1 }))
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.code != 'P03')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (onStartProcess(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("发起")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _unref(data).form_visible,
      title: "新建流程",
      width: "40%",
      onCancel: hideForm,
      confirmLoading: _unref(data).form_loading,
      onOk: submit
    }, {
      default: _withCtx(() => [
        _createVNode(ProcessForm, {
          id: _unref(data).processId,
          type: _unref(data).type
        }, null, 8, ["id", "type"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ]))
}
}

})